import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

/**
 * SEO Head Component
 * Provides page-specific meta tags for better SEO
 */
export const SEOHead = ({
  title = 'D3 Command | AI-Powered Operational Governance Platform',
  description = 'D3 Command transforms conversations into execution, analytics, and compliance. AI-powered meeting intelligence, workflow automation, and enterprise governance.',
  keywords = 'AI meeting intelligence, workflow automation, compliance, governance, enterprise platform, operational excellence, meeting transcription, task automation',
  image = 'https://www.d3command.com/d3-logo-full.png',
  url = 'https://www.d3command.com',
  type = 'website',
  noindex = false,
}) => {
  const fullTitle = title.includes('D3 Command') ? title : `${title} | D3 Command`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="D3 Command" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="author" content="D3 Command" />
      <meta name="application-name" content="D3 Command" />
      <meta name="apple-mobile-web-app-title" content="D3 Command" />
    </Helmet>
  );
};

/**
 * SEO Provider - Wrap your app with this
 */
export const SEOProvider = ({ children }) => {
  return <HelmetProvider>{children}</HelmetProvider>;
};

export default SEOHead;
